import {ExposeModuleExports, Log} from "web-vcore";
import {InitGraphlink} from "./MobXGraphlink.js";
import {InitReactJS} from "./ReactJS.js";
import {InitReactVComponents} from "./ReactVComponents.js";
import {InitSentry} from "./Sentry.js";
import {InitWVC} from "./WVC.js";
import {InitApollo} from "./Apollo.js";
import {enableMapSet} from "immer";
import {sealedProps_differenceInterceptor_set} from "react-vextensions";

// helpers for exposing things (making them easier to access in console/dev-tools)
function ExposeGlobals() {
	// set some globals
	G({Log});
}
function ExposeModuleExports_Final() {
	// expose exports
	if (DEV) {
		setTimeout(()=>{
			ExposeModuleExports();
		}, 500); // wait a bit, since otherwise some modules are missed/empty during ParseModuleData it seems
	} else {
		G({RR: ()=>ExposeModuleExports()});
	}
}

export function InitLibs() {
	InitApollo();
	InitWVC();
	InitGraphlink(); // init this early, so we can use mobx-graphlink's DBPath() for the later modules (eg. graphql-feedback)
	//InitFeedback();
	//InitForum();
	InitSentry();
	InitReactJS();
	InitReactVExtensions();
	InitReactVComponents();

	// extra; weird thing for immer
	enableMapSet();

	// start auto-runs, now that store+firelink are initialized (store has not yet loaded data from disk, in RootUIWrapper.ComponentWillMount, but that's fine)
	require("../AutoRuns/index.js");

	ExposeGlobals();
	ExposeModuleExports_Final();
}

// minor lib-inits
// ==========

function InitReactVExtensions() {
	sealedProps_differenceInterceptor_set((classWherePropsSealed, sealedEntry, compInstance)=>{
		// detect if a componentDidMount entry matches the wrapper we know mobx-react will be adding
		//if (sealedEntry.name == "componentDidMount" && compInstance["mobxReactionDisposer"]) {
		if (sealedEntry.name == "componentDidMount") {
			const patchedFuncStr = compInstance[sealedEntry.name].toString();
			if (patchedFuncStr.includes("[mobx-react] `observer(") && patchedFuncStr.includes(").componentDidMount` must be defined on prototype.")) {
				return "allow";
			}
		}
		return "noChange";
	});
}